<template>
    <div class="flex h-6 items-center">
        <svg-icon
            v-if="icon"
            :icon="icon"
            class="my-auto mr-2 h-6 w-6 align-middle"
            icon-class="text-theme-icon"
            :fill="iconCustomFill"
        />
        <h2 v-if="title" class="my-auto align-middle text-base font-medium leading-none text-theme-text">
            {{ title }}
        </h2>
    </div>
</template>

<script>
export default {
    name: 'IntegrationHeader',
    props: {
        icon: {
            type: String,
            required: false,
            default: '',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        iconCustomFill: {
            type: String,
            default: null,
        },
    },
};
</script>
